import {Button, styled} from "@mui/material";

const ToolbarButton = styled(Button)(({theme})=>({
    padding:theme.spacing(0.5,.5),
    minWidth:24,
}));

export default ToolbarButton;